import { isArray } from "lodash";

const getOneLatest = (array, by = "createdAt") => {
  try {
    if (!isArray(array)) throw new Error("Array is not array");
    const latestObject = array.reduce((max, current) =>
      max?.["createdAt"] > current?.["createdAt"] ? max : current
    );
    return latestObject;
  } catch (err) {
    console.error(err);
    return undefined;
  }
};

export default getOneLatest;
